"use strict";

const state = {
  pendingRates: {
    totalCount: 0,
    items: null
  },
  pendingApprovals: {
    totalCount: 0,
    items: null
  },
  requestAccess: {
    totalCount: 0,
    items: null
  },
  approvals: {
    totalCount: 0,
    items: null,
    unread: null
  }
};

const mutations = {
  SOCKET_PENDING_RATES_REMOVE(state, value) {
    const idx = state.pendingRates.items.findIndex(item => {
      return item._id == value.id;
    });
    if (idx >= 0) {
      state.pendingRates.items.splice(idx, 1);
      state.pendingRates.totalCount--;
    }
  },
  SOCKET_PENDING_RATES(state, value) {
    state.pendingRates = value;
  },
  substractPendingRate(state, visitId) {
    const idx = state.pendingRates.items.findIndex(item => {
      return item._id == visitId;
    });
    if (idx >= 0) {
      state.pendingRates.items.splice(idx, 1);
      state.pendingRates.totalCount--;
    }
  },
  SOCKET_PENDING_APPROVALS(state, value) {
    state.pendingApprovals = value;
  },
  substractPendingApprovals(state, notificationId) {
    const idx = state.pendingApprovals.items.findIndex(item => {
      return item._id == notificationId;
    });
    if (idx >= 0) {
      state.pendingApprovals.items.splice(idx, 1);
      state.pendingApprovals.totalCount--;
    }
  },
  SOCKET_APPROVALS(state, value) {
    state.approvals = value;
  },
  substractApprovals(state, notificationId) {
    const idx = state.approvals.items.findIndex(item => {
      return item._id == notificationId;
    });
    if (idx >= 0) {
      state.approvals.items.splice(idx, 1);
      state.approvals.totalCount--;
    }
  },
  SOCKET_PENDING_REQUEST_ACCESS_REMOVE(state, value) {
    if (state.requestAccess.items && state.requestAccess.items.length > 0) {
      const idx = state.requestAccess.items.findIndex(
        r => r.data.requestAccess._id == value.id
      );
      if (idx >= 0) {
        state.requestAccess.items.splice(idx, 1);
        state.requestAccess.totalCount--;
      }
    }
  },
  SOCKET_PENDING_REQUEST_ACCESS(state, value) {
    state.requestAccess = value;
  },
  substractRequestAccess(state, notificationId) {
    const idx = state.requestAccess.items.findIndex(item => {
      return item._id == notificationId;
    });
    if (idx >= 0) {
      state.requestAccess.items.splice(idx, 1);
      state.requestAccess.totalCount--;
    }
  },
};

const actions = {};

export default {
  state,
  mutations,
  actions
};
